import { render, staticRenderFns } from "./ProductManager.vue?vue&type=template&id=7f4eae62&"
import script from "./ProductManager.vue?vue&type=script&lang=js&"
export * from "./ProductManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports